export const meteringPointAdminColumns = [
  "eic",
  "client",
  "address",
  "city",
  "connectionState",
  "consumptionScale",
  "meteringType",
  "isBorderPoint",
  "isActive",
  "productionPark",
  "operatorEic",
];

export const meteringPointAdminColumnsPlaceholders = [
  "EIC",
  "Client",
  "Address",
  "City",
  "Connection status",
  "Scale",
  "Type",
  "Border",
  "Active",
  "Production Park",
  "Operator EIC",
];

export const meteringPointUserColumns = () => {
  return [
    "eic",
    "address",
    "city",
    "connectionState",
    "consumptionScale",
    "meteringType",
    "isBorderPoint",
    "isActive",
    "productionPark",
    "operatorEic",
  ];
};

export const meteringPointUserColumnsPlaceholders = (
  includeProductionPark = false,
) => {
  const columns = [
    "EIC",
    "Address",
    "City",
    "Connection status",
    "Scale",
    "Type",
    "Border",
    "Active",
  ];

  if (includeProductionPark) {
    columns.push("Production Park");
  }

  columns.push("Operator EIC");

  return columns;
};
